import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

import { icons } from '@/constants/icons'

export const ToggleWrapper = styled.div<{
  $small: boolean
}>`
  position: relative;
  width: ${({ $small }) => ($small ? '60px' : '80px')};
  height: ${({ $small }) => ($small ? '30px' : '40px')};
`

export const ToggleEl = styled(FocusNode)<{
  $isChecked: boolean
  $disabled: boolean
  $small: boolean
}>`
  width: ${({ $small }) => ($small ? '60px' : '80px')};
  height: ${({ $small }) => ($small ? '30px' : '40px')};
  background: ${({ $disabled, theme }) =>
    $disabled
      ? theme.colors.toggle.disabledElem.background
      : theme.colors.toggle.background};
  border: 2px solid
    ${({ $disabled, theme }) =>
      $disabled
        ? theme.colors.toggle.disabledElem.border
        : theme.colors.toggle.border};
  position: absolute;
  top: 0;
  left: 0;
  border-radius: ${({ $small }) => ($small ? '15px' : '20px')};
  &.isFocusedLeaf {
    border: 0;
    border: 2px solid ${(props) => props.theme.colors.toggle.focusedElem.border};
  }
  &:before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    opacity: ${({ $disabled }) => ($disabled ? '0.3' : '0.4')};
    background-image: ${({ $isChecked }) =>
      $isChecked
        ? `url(${icons.navigation.check})`
        : `url(${icons.navigation.exit})`};
    background-repeat: no-repeat;
    background-position: ${({ $isChecked }) =>
      $isChecked ? '12% 50%' : '88% 50%'};
    background-size: auto 80%;
  }
  &:after {
    position: absolute;
    content: '';
    width: ${({ $small }) => ($small ? '18px' : '28px')};
    height: ${({ $small }) => ($small ? '18px' : '28px')};
    left: 4px;
    top: 4px;
    transform: ${({ $isChecked, $small }) =>
      $isChecked
        ? $small
          ? 'translateX(30px)'
          : 'translateX(40px)'
        : 'translateX(0px)'};
    transition: background-color 0.15s ease, transform 0.15s ease;
    border-radius: 50%;
    z-index: 1;
    background: ${({ $disabled, theme }) =>
      $disabled
        ? theme.colors.toggle.disabledElem.toggleColor
        : theme.colors.toggle.toggleColor};
  }
`
